import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Anchor, Wind } from "lucide-react";

const FLEET = [
  {
    name: "Tamara",
    img: "https://customer-assets.emergentagent.com/job_vivendi-sailing/artifacts/fsdglygy_7abd56db-9ded-4136-a3a3-7be8df5e84ae.png",
    pos: "object-[center_20%]",
  },
  {
    name: "Aurora",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_vivendi-sailing/artifacts/3mfh522n_IMG-155d534a55e7ef9253cb3a384d60cd0a-V.jpg",
    pos: "object-center",
  },
];

export default function Fleet() {
  const { t } = useTranslation();
  return (
    <section id="fleet" data-testid="fleet-section" className="relative py-24 lg:py-36 bg-[#0A1B35] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#D1BFAe]" />
              <span className="overline text-[#D1BFAe]">{t("fleet.eyebrow")}</span>
            </div>
            <h2
              data-testid="fleet-title"
              className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
            >
              {t("fleet.title_pre")} <em className="italic text-[#D1BFAe]">{t("fleet.title_em")}</em>
            </h2>
          </div>
          <p className="max-w-md text-white/70 font-light leading-relaxed">
            {t("fleet.body")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
          {FLEET.map((f, i) => (
            <motion.div
              key={f.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="bento-card aspect-[9/16]"
              data-testid={`fleet-card-${i}`}
            >
              <img
                src={f.img}
                alt={f.name}
                className={`absolute inset-0 w-full h-full object-cover ${f.pos || "object-center"}`}
              />
              <div className="overlay" />
              <div className="absolute inset-0 p-6 lg:p-10 flex flex-col justify-between">
                <div className="flex items-center gap-2 text-white/80">
                  <Anchor className="w-4 h-4" strokeWidth={1.3} />
                  <span className="overline text-[0.6rem]">{t("fleet.guests")}</span>
                </div>
                <div>
                  <div className="font-serif-display text-4xl lg:text-5xl">{f.name}</div>
                  <div className="overline text-[#D1BFAe] mt-2">{t("fleet.type")}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 grid sm:grid-cols-2 gap-8 border-t border-white/10 pt-10 text-white/70">
          {[
            { n: "27ft", l: t("fleet.stat_length") },
            { n: "3,400+", l: t("fleet.stat_built") },
          ].map((s, i) => (
            <div key={i}>
              <div className="font-serif-display text-3xl lg:text-4xl text-white">{s.n}</div>
              <div className="overline mt-1">{s.l}</div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex items-center gap-3 text-white/60">
          <Wind className="w-4 h-4" strokeWidth={1.2} />
          <span className="overline text-[0.65rem]">{t("fleet.wind")}</span>
        </div>
      </div>
    </section>
  );
}
